export class IPermission {
  permissionName: string;
  applicationVariantName: string;
}
